import { SITE, waLink } from "../data/site";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-[#04120E] py-14" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-emerald-100/50 leading-relaxed max-w-xs">
            Desconto de até 15% na conta de luz com energia solar de usinas parceiras, conforme a sua região.
            Sem obra e sem investimento.
          </p>
        </div>
        <div>
          <p className="text-xs font-mono2 uppercase tracking-[0.2em] text-[#00E676] mb-4">Navegação</p>
          <nav className="grid grid-cols-2 gap-2.5 text-sm text-emerald-100/60">
            {[
              ["#como-funciona", "Como funciona"], ["#simular", "Simulador"], ["#depoimentos", "Depoimentos"],
              ["#clube", "iGreen Club"], ["#servicos", "Serviços"], ["#faq", "Dúvidas"],
              ["#conectar", "Conectar grátis"], ["#lead-form", "Quero economizar"],
            ].map(([href, label]) => (
              <a key={href} href={href} className="hover:text-[#00E676] transition-colors duration-300">{label}</a>
            ))}
          </nav>
        </div>
        <div>
          <p className="text-xs font-mono2 uppercase tracking-[0.2em] text-[#00E676] mb-4">Atendimento</p>
          <p className="text-sm text-emerald-100/60 leading-relaxed">
            {SITE.licenciado}<br />
            Licenciado Autorizado iGreen Energy<br />
            ID {SITE.licenciadoId}
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-cta"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#00E676]/35 text-[#00E676] text-sm font-semibold px-5 py-2.5 hover:bg-[#00E676]/10 transition-colors duration-300"
          >
            Falar comigo no WhatsApp
          </a>
        </div>
      </div>
      <div className="mt-12 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-emerald-100/35">
        <p>© 2026 {SITE.brand} · Licenciado Autorizado iGreen Energy (ID {SITE.licenciadoId})</p>
        <span className="flex gap-4">
          <a href="/privacidade" data-testid="footer-privacy-link" className="hover:text-[#00E676] transition-colors duration-300">Política de privacidade</a>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#00E676] transition-colors duration-300">Área do licenciado</a>
        </span>
      </div>
    </div>
  </footer>
);
